module.exports = __webpack_public_path__ + "new-agent/static/fonts/MaterialIcons-Regular.fc6295a.ttf";